import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ClassicIconWithTBO: React.FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 1483 579" {...props} style={{ width: '70%', height: '100%' }}>
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M947.987976,227.068329 
	C947.994019,218.285065 947.879089,209.498459 948.121338,200.721725 
	C948.163269,199.203339 949.718384,197.726730 950.574585,196.230835 
	C951.380676,197.778183 952.740051,199.272476 952.894409,200.882324 
	C953.477051,206.959824 953.668213,213.074844 954.004150,220.057739 
	C954.682617,224.338943 955.362854,227.738220 956.043091,231.137497 
	C958.256592,258.444824 978.124939,279.278442 1006.462891,282.783417 
	C1018.239258,284.240021 1030.339722,284.908966 1042.136963,283.973022 
	C1065.013306,282.158112 1075.990845,266.274628 1078.603027,246.654861 
	C1080.772705,230.359802 1078.962646,214.244263 1068.262939,200.627396 
	C1065.016113,196.495361 1061.265625,192.454208 1056.968628,189.503174 
	C1034.062866,173.772400 1010.881836,158.443253 987.855225,142.887634 
	C975.400513,134.473877 963.710144,125.111931 954.582092,113.028610 
	C938.559814,91.819138 940.830200,56.064102 961.729492,37.410080 
	C974.715881,25.818848 990.120911,20.889208 1006.701843,19.172178 
	C1034.528198,16.290636 1061.710327,20.155117 1088.214111,28.943394 
	C1091.049438,29.883528 1093.695923,31.521055 1096.579712,32.161770 
	C1103.930420,33.795040 1105.361572,38.417210 1105.150391,45.331280 
	C1104.672119,60.977913 1104.999634,76.649170 1104.998779,92.310410 
	C1104.998779,93.310059 1105.283203,94.430573 1104.927734,95.283150 
	C1104.270874,96.858353 1103.237549,98.276497 1102.361084,99.760086 
	C1101.578003,98.350815 1100.284668,97.003113 1100.105713,95.520897 
	C1099.529907,90.750023 1099.464355,85.920387 1099.023071,81.129913 
	C1097.744141,67.248901 1093.665405,54.327335 1084.609985,43.508484 
	C1077.203979,34.660431 1067.229004,29.634293 1056.186035,26.985062 
	C1043.068604,23.838158 1029.783813,21.663803 1016.216858,23.739044 
	C986.278137,28.318567 972.042236,60.754292 984.290405,87.618477 
	C989.050659,98.059387 996.370422,106.187088 1005.861877,112.570618 
	C1028.918701,128.077606 1052.158081,143.334351 1074.803955,159.423645 
	C1090.695190,170.714020 1104.186646,184.495239 1111.144897,203.388641 
	C1120.918701,229.926422 1112.728271,262.243835 1085.880249,277.649597 
	C1073.603882,284.693878 1060.431519,287.819733 1046.516113,289.074036 
	C1019.571228,291.502747 993.510559,287.628235 968.053528,278.869720 
	C967.423828,278.653076 966.803223,278.410126 966.174744,278.189911 
	C948.811096,272.105560 947.999207,270.974518 947.998596,252.870972 
	C947.998474,249.205399 947.994629,245.539810 948.018921,240.942169 
	C948.026245,235.696182 948.007080,231.382248 947.987976,227.068329 
z"
      />
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M767.705933,267.959747 
	C789.479553,284.994446 814.669495,287.116943 840.663635,283.651276 
	C859.202271,281.179657 872.645935,265.065002 873.868652,245.212875 
	C874.669373,232.211868 874.379333,219.281479 867.748169,207.305435 
	C862.936462,198.615112 856.242676,191.901627 848.117859,186.467316 
	C826.261230,171.848312 804.319519,157.355942 782.515015,142.659775 
	C770.616577,134.640289 759.177246,125.880539 750.636353,114.223671 
	C728.032532,83.373535 738.646301,38.161594 778.994019,24.254780 
	C794.695435,18.842928 810.951233,17.586191 827.627258,18.657261 
	C843.314331,19.664804 858.727478,21.694323 873.779358,26.050800 
	C881.266479,28.217785 888.492188,31.285948 895.841492,33.931728 
	C898.912537,35.037357 900.065979,37.129379 900.045593,40.436596 
	C899.933411,58.596706 900.062256,76.758591 899.874390,94.917442 
	C899.857727,96.535751 898.166321,98.136719 897.252686,99.745728 
	C896.503235,98.138336 895.341858,96.597076 895.071472,94.912788 
	C893.340515,84.130989 893.039124,72.950348 889.953857,62.589901 
	C883.107605,39.599720 865.628174,28.638500 842.865845,25.123631 
	C831.712830,23.401421 820.524902,21.755747 809.173157,24.006363 
	C787.069397,28.388697 771.540894,51.649384 775.355469,73.895882 
	C778.249207,90.771553 787.223816,103.229263 801.018127,112.619759 
	C824.263123,128.443817 847.951782,143.647675 870.739075,160.102203 
	C887.061890,171.888779 901.315002,186.171692 907.141602,206.355682 
	C913.986877,230.068710 909.874939,251.695801 891.930481,269.380981 
	C880.798157,280.352386 866.622070,285.676727 851.287598,287.977936 
	C821.403381,292.462616 792.343079,288.772186 763.490112,278.736755 
	C764.635986,274.857758 766.170959,271.408752 767.705933,267.959747 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M1221.129517,280.081970 
	C1222.926270,278.667328 1224.600220,277.046875 1226.547485,275.884338 
	C1229.788330,273.949585 1233.366333,274.475769 1235.392212,277.287720 
	C1236.424561,278.720520 1235.917969,282.218506 1234.850342,284.050507 
	C1228.537598,294.882446 1221.846191,305.493439 1215.307983,316.194580 
	C1214.233887,317.952545 1213.287964,319.788910 1212.053467,321.999847 
	C1234.896973,321.999847 1257.055542,321.871033 1279.211792,322.039185 
	C1298.144165,322.182861 1317.074951,322.620758 1336.004639,323.018799 
	C1347.271851,323.255737 1358.537231,323.613312 1369.799561,324.022247 
	C1375.569824,324.231750 1381.329590,324.712524 1387.097778,324.997498 
	C1391.625122,325.221100 1391.302490,328.433197 1390.924561,331.388977 
	C1390.527222,334.495941 1388.859619,337.074036 1385.324219,335.888977 
	C1375.230835,332.505737 1364.841675,333.137848 1354.480957,332.982605 
	C1336.382324,332.711487 1318.285400,332.324005 1300.187622,332.001373 
	C1280.923462,331.657898 1261.659912,331.159698 1242.394409,331.068848 
	C1231.797729,331.018860 1221.186401,331.478943 1210.605103,332.104034 
	C1206.857056,332.325470 1203.596558,333.996704 1201.540771,337.822357 
	C1188.806152,361.521057 1175.745117,385.044861 1163.077271,408.778748 
	C1144.192871,444.159515 1126.462891,480.082336 1113.412720,518.122681 
	C1112.414062,521.033569 1110.592163,523.908752 1115.024170,525.872559 
	C1115.521484,526.092957 1115.188110,530.445190 1114.513184,530.666687 
	C1111.441895,531.674622 1107.987305,532.672241 1104.905151,532.186218 
	C1101.312744,531.619812 1099.337280,528.190430 1100.109131,524.645264 
	C1101.902344,516.410339 1103.428345,507.959961 1106.568359,500.206757 
	C1114.256104,481.225098 1122.796387,462.588715 1131.307495,443.327332 
	C1131.671021,442.389771 1131.720581,441.938293 1131.770142,441.486755 
	C1131.289429,441.759521 1130.808716,442.032288 1130.328003,442.305054 
	C1117.711426,447.925934 1105.306396,454.117004 1092.382080,458.907959 
	C1086.611206,461.047211 1079.803345,460.735413 1073.454590,460.840332 
	C1069.616333,460.903748 1065.968018,455.431976 1066.090942,450.123199 
	C1066.198364,445.480042 1067.074097,440.854675 1067.662598,435.770874 
	C1062.332764,438.738312 1057.281494,441.612732 1052.169556,444.375000 
	C1048.754395,446.220398 1045.364380,448.190796 1041.765015,449.598663 
	C1035.898560,451.893311 1032.288940,447.785828 1033.348511,440.153900 
	C1025.615479,445.572174 1018.088013,451.162231 1010.245178,456.267731 
	C998.345947,464.013855 985.963684,470.949036 971.784363,473.557648 
	C964.063965,474.977997 953.106018,473.057892 951.413513,464.539185 
	C950.306519,458.967621 951.006592,452.954041 951.470215,447.184479 
	C951.750183,443.700531 953.126831,440.304718 954.316162,436.355347 
	C954.671143,435.389893 954.720764,434.938416 954.770386,434.486938 
	C954.289673,434.759460 953.808960,435.032013 953.328247,435.304565 
	C938.216125,442.869934 923.106689,450.440552 907.990845,457.998505 
	C900.593689,461.697052 892.623718,461.174042 884.747375,460.916260 
	C881.602173,460.813354 877.942932,455.459351 878.069763,451.086823 
	C878.219727,445.916046 878.886169,440.760284 879.291992,436.026581 
	C871.882568,440.003937 863.959900,444.367188 855.914490,448.491180 
	C854.103455,449.419495 851.843201,449.974640 849.827087,449.882843 
	C846.755371,449.742920 844.668762,448.277496 844.953003,444.513672 
	C845.628967,435.561981 850.329895,428.533600 855.702148,421.932007 
	C858.398132,418.618927 861.479553,415.237518 865.112000,413.148071 
	C872.596252,408.843109 880.444092,407.227112 887.750671,414.097595 
	C888.383301,414.692474 889.785950,414.463593 890.829285,414.627747 
	C892.916992,414.956146 896.108765,414.613922 896.827271,415.785675 
	C897.861877,417.472900 897.755371,420.514618 896.981140,422.535950 
	C894.481323,429.062012 891.358337,435.346436 888.684814,441.810547 
	C887.838257,443.857178 887.055176,446.240417 887.286987,448.355194 
	C887.712646,452.237732 891.884216,454.095856 896.691101,452.633270 
	C903.673340,450.508789 910.912354,448.805054 917.425415,445.649475 
	C931.342712,438.906586 945.094604,431.737488 958.408508,423.885345 
	C962.425720,421.516144 964.632385,416.195038 967.928711,412.455505 
	C972.016052,407.818359 976.114319,403.133118 980.683411,398.993530 
	C985.905579,394.262177 994.608215,395.071381 998.997742,398.613586 
	C1003.019226,401.858795 1004.334290,411.147980 1001.372864,415.969391 
	C1000.482178,417.419464 998.133484,418.871704 996.565918,418.758240 
	C994.968445,418.642609 993.255554,416.807526 992.066223,415.341583 
	C990.976746,413.998810 990.518677,412.143768 989.607788,410.128174 
	C982.436584,414.634247 977.083984,420.792023 973.134888,427.918549 
	C968.173279,436.872284 963.100647,445.964294 963.017273,456.681183 
	C962.953064,464.941345 965.936707,466.991364 974.023621,464.503693 
	C988.302307,460.111298 1001.531616,453.461365 1014.005127,445.372223 
	C1022.345093,439.963684 1030.518066,434.238495 1038.331299,428.101898 
	C1042.223267,425.045074 1045.174927,420.776886 1048.489380,417.001801 
	C1054.464722,410.195953 1062.337280,409.045898 1070.580688,410.211945 
	C1073.133423,410.573029 1075.370728,413.164185 1078.408081,415.166473 
	C1078.982788,414.994812 1080.617188,414.133942 1082.272705,414.091339 
	C1085.526733,414.007568 1087.645630,416.976349 1086.374023,420.077057 
	C1083.781738,426.397675 1080.839355,432.574860 1078.037231,438.809296 
	C1077.770386,439.403046 1077.251343,439.975220 1077.228638,440.571808 
	C1077.090576,444.200317 1075.817139,448.622070 1077.440308,451.183899 
	C1078.502808,452.860901 1084.007812,452.663055 1087.187988,451.902924 
	C1105.281860,447.578003 1121.368164,438.509186 1137.526733,429.704559 
	C1138.656738,429.088776 1139.299561,427.412109 1139.957275,426.120972 
	C1149.445190,407.493591 1158.727539,388.759155 1168.420654,370.239441 
	C1174.237305,359.126160 1180.696167,348.349518 1186.819580,337.395355 
	C1187.428833,336.305603 1187.710693,335.032928 1188.432251,333.057098 
	C1185.627075,333.057098 1183.385010,332.935791 1181.161743,333.088684 
	C1178.555176,333.267914 1175.970581,333.896912 1173.366943,333.965118 
	C1157.937866,334.369324 1142.460938,334.046509 1127.087158,335.165253 
	C1109.617676,336.436554 1092.240356,338.969482 1074.820801,340.934540 
	C1073.832031,341.046051 1072.823608,340.988525 1071.824097,340.998322 
	C1064.156006,341.073700 1060.234497,338.828888 1060.012207,334.240448 
	C1059.803223,329.927307 1065.258179,325.342773 1071.670654,325.069031 
	C1078.682251,324.769745 1085.719482,325.125488 1092.739868,324.957764 
	C1098.342651,324.823914 1103.933594,324.124359 1109.535522,324.036102 
	C1135.796875,323.622345 1162.059814,323.289459 1188.323242,323.044128 
	C1192.531006,323.004791 1195.484985,321.183136 1197.585938,317.813477 
	C1204.042358,307.458984 1210.416626,297.053314 1217.275513,286.240417 
	C1218.861938,283.902832 1219.995728,281.992401 1221.129517,280.081970 
M1067.081299,423.437164 
	C1067.672119,422.800415 1068.262939,422.163635 1068.853882,421.526917 
	C1067.397705,421.024689 1065.699585,419.766968 1064.524536,420.143127 
	C1057.027344,422.543091 1051.739746,427.515015 1047.757690,435.857330 
	C1054.804321,431.398773 1060.672729,427.685669 1067.081299,423.437164 
M861.929077,431.393250 
	C861.272400,432.407776 860.615662,433.422333 859.958984,434.436859 
	C860.273621,434.650330 860.588257,434.863831 860.902893,435.077301 
	C867.359741,430.886200 873.816589,426.695068 880.577515,422.306549 
	C877.553162,418.709076 874.578735,419.676758 872.282715,421.426605 
	C868.639221,424.203278 865.444031,427.568207 861.929077,431.393250 
z"
      />
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M519.819458,240.898621 
	C519.190002,247.913025 517.816833,254.576950 518.294922,261.105286 
	C519.149231,272.769623 528.865784,280.172791 542.509827,281.072083 
	C544.633911,281.212036 548.487976,282.616699 548.463379,283.330078 
	C548.315369,287.605957 544.594727,285.903412 542.336670,285.918030 
	C521.342773,286.054169 500.347595,286.003815 479.352783,285.986786 
	C477.860718,285.985596 476.305237,286.041473 474.903473,285.638519 
	C474.197510,285.435547 473.348389,284.268341 473.336395,283.524689 
	C473.324432,282.781677 474.217407,281.417145 474.814545,281.358917 
	C496.770294,279.217285 503.882690,261.634583 510.495422,245.154770 
	C522.570984,215.060837 533.043457,184.323608 544.185669,153.855133 
	C557.956848,116.197662 571.731140,78.541344 585.498596,40.882534 
	C587.269714,36.037827 588.857239,31.118080 590.845276,26.365044 
	C591.519775,24.752346 593.166992,23.546484 594.369690,22.154703 
	C595.637390,23.460363 597.454285,24.542063 598.091492,26.104813 
	C610.404724,56.302853 622.622375,86.540161 634.773682,116.803917 
	C653.371643,163.123260 671.823975,209.501312 690.558838,255.765076 
	C693.093994,262.025391 696.780212,267.841278 700.167847,273.728058 
	C703.072327,278.775116 707.748962,280.841461 713.500916,281.109589 
	C714.951782,281.177185 716.341736,282.550262 717.759705,283.323486 
	C716.291443,284.212555 714.828430,285.866180 713.354065,285.876343 
	C690.027649,286.037537 666.699524,286.029449 643.372925,285.882080 
	C641.981445,285.873322 640.599426,284.362213 639.213013,283.550201 
	C640.390015,282.700287 641.474426,281.303864 642.758545,281.086426 
	C653.569031,279.255646 657.527344,273.956390 654.329834,263.028320 
	C651.258057,252.529922 646.919067,242.397842 643.031677,232.144669 
	C641.381348,227.791534 639.094482,223.649948 637.769897,219.211395 
	C636.450378,214.789886 633.831726,213.895508 629.622925,213.922180 
	C604.296814,214.082581 578.969299,214.001373 553.642212,214.001602 
	C546.810547,214.001663 539.975159,214.139557 533.148865,213.948532 
	C529.623779,213.849899 527.609192,214.975769 526.613708,218.534958 
	C524.553406,225.901077 522.164001,233.175156 519.819458,240.898621 
M618.001282,168.488678 
	C605.482971,136.329498 592.964661,104.170311 580.446350,72.011139 
	C580.029419,72.011711 579.612488,72.012283 579.195557,72.012848 
	C562.848816,117.346275 546.502075,162.679688 529.917358,208.673233 
	C564.958984,208.673233 598.836670,208.673233 633.718384,208.673233 
	C628.396484,195.116714 623.314575,182.171432 618.001282,168.488678 
z"
      />
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M326.262024,40.494965 
	C325.061859,46.530190 323.148895,52.218746 323.132812,57.912670 
	C322.929169,129.882172 322.997192,201.852463 323.001221,273.822540 
	C323.001648,280.978699 323.018005,280.991211 330.160919,280.995941 
	C344.488312,281.005402 358.831604,281.419250 373.138367,280.876160 
	C386.092926,280.384369 398.922913,278.687286 410.967041,273.084595 
	C426.465240,265.875153 435.574402,253.472900 439.748352,237.464142 
	C441.994843,228.847870 442.576569,219.803864 444.096100,210.985016 
	C444.326752,209.646515 445.573730,208.483139 446.350647,207.238770 
	C447.227844,208.551514 448.861206,209.859268 448.869904,211.177750 
	C449.024811,234.666901 448.939575,258.157501 449.026825,281.647369 
	C449.040649,285.372589 447.138306,286.045380 444.006866,286.025360 
	C431.845795,285.947510 419.683868,285.998505 407.522278,285.998688 
	C361.541382,285.999359 315.560516,285.999084 269.579620,285.998169 
	C268.080261,285.998138 266.504150,286.274536 265.103333,285.900116 
	C263.725250,285.531708 262.524963,284.498016 261.246674,283.756287 
	C262.512238,282.839874 263.698700,281.273499 265.055695,281.108368 
	C277.506256,279.593262 284.623291,273.729156 287.465546,261.809540 
	C288.383453,257.960052 288.928223,253.922104 288.933685,249.969391 
	C289.022308,185.996109 289.022186,122.022636 288.934021,58.049362 
	C288.928589,54.096432 288.386444,50.058987 287.472290,46.208458 
	C284.658295,34.355103 278.155640,28.913496 265.541962,26.954437 
	C264.006134,26.715904 262.672638,25.174459 261.245392,24.236841 
	C262.859161,23.493086 264.469666,22.109190 266.087158,22.101053 
	C292.742065,21.966986 319.398041,21.965797 346.052856,22.107763 
	C347.630615,22.116167 349.200531,23.587564 350.774109,24.378170 
	C349.291901,25.272633 347.900940,26.701242 346.312286,26.972605 
	C337.687683,28.445824 330.351959,31.666744 326.262024,40.494965 
z"
      />
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M52.081490,118.191269 
	C51.362221,134.567886 49.720192,150.530472 50.217056,166.426208 
	C51.026031,192.306946 54.870838,217.729630 67.485413,241.041016 
	C81.060692,266.127747 101.863091,280.467590 130.157196,284.048523 
	C149.007095,286.434174 167.341904,284.741852 184.841812,277.032715 
	C202.744812,269.146027 213.306290,254.975006 217.804794,236.329254 
	C219.620422,228.803650 219.896805,220.914124 221.067398,213.219681 
	C221.328720,211.502014 222.404114,209.908203 223.104721,208.257355 
	C224.215118,209.775482 226.040543,211.179855 226.303543,212.832809 
	C227.135254,218.059952 227.468887,223.374084 227.837601,228.665543 
	C228.610825,239.761978 229.188110,250.872818 230.048004,261.962067 
	C230.359451,265.978577 228.731689,268.292023 225.427628,270.450104 
	C210.340256,280.304596 193.732162,285.908508 175.989471,287.855347 
	C164.123749,289.157318 152.111435,290.153717 140.203537,289.835236 
	C111.762779,289.074524 84.890305,282.556183 61.480240,265.282074 
	C39.460358,249.033813 25.643913,227.236679 18.048233,201.223175 
	C12.433534,181.994080 10.969680,162.256134 12.124019,142.422943 
	C13.675713,115.762619 20.411863,90.511505 36.188171,68.445007 
	C54.491409,42.844082 79.700012,27.771093 110.321152,21.771458 
	C141.150177,15.731089 171.816818,16.654255 201.880539,26.252806 
	C208.786255,28.457617 215.253876,32.135361 221.767868,35.441132 
	C230.120468,39.679962 230.828308,41.867470 229.928192,51.302071 
	C228.699341,64.182549 227.975616,77.110771 226.974121,90.013779 
	C226.782059,92.488205 226.513718,94.997375 225.861389,97.375542 
	C225.598053,98.335602 224.209442,98.987007 223.332932,99.778877 
	C222.576752,98.858971 221.270126,98.001320 221.157867,97.008591 
	C220.617615,92.231216 220.577637,87.397148 220.033813,82.620338 
	C218.413132,68.384186 213.535919,55.302567 203.878052,44.660374 
	C194.439453,34.259766 182.152344,28.396193 168.403580,25.633801 
	C141.285538,20.185257 115.345757,22.279428 91.964836,38.482765 
	C77.418922,48.563305 67.670280,62.725739 62.027035,79.207680 
	C57.743515,91.718346 55.352364,104.876938 52.081490,118.191269 
z"
      />
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M1400.975464,19.001322 
	C1423.166504,19.772303 1443.271973,25.835432 1462.163452,36.588638 
	C1468.232910,40.043427 1468.337891,44.777592 1467.874023,50.452435 
	C1466.819580,63.350452 1465.963989,76.264626 1464.983032,89.168831 
	C1464.794922,91.644096 1464.670288,94.180611 1463.994507,96.539314 
	C1463.639526,97.778175 1462.154297,98.693184 1461.179321,99.754379 
	C1460.458130,98.457901 1459.279907,97.224068 1459.092163,95.854523 
	C1458.102417,88.630203 1457.998779,81.229996 1456.423096,74.150047 
	C1450.239990,46.368721 1432.170044,30.659861 1404.780518,25.257038 
	C1386.401611,21.631622 1368.097900,21.907871 1350.149780,28.088167 
	C1330.687500,34.789837 1316.320679,47.481720 1306.360352,65.310036 
	C1296.793335,82.433929 1291.593750,100.975929 1290.072266,120.396629 
	C1288.814575,136.448975 1287.567871,152.632553 1288.242676,168.676971 
	C1289.402710,196.264038 1293.976318,223.264938 1309.102173,247.311630 
	C1322.557129,268.701752 1342.113037,280.418976 1366.868896,283.969635 
	C1383.258789,286.320404 1399.390625,285.061615 1415.154175,280.066010 
	C1436.793945,273.208191 1450.188721,258.305084 1455.743652,236.567947 
	C1457.658081,229.076645 1457.862183,221.158066 1459.075562,213.470657 
	C1459.363647,211.645554 1460.568970,209.965240 1461.352417,208.218323 
	C1462.402832,209.830032 1464.129395,211.344238 1464.378540,213.071518 
	C1465.158081,218.477478 1465.428467,223.960510 1465.808350,229.419785 
	C1466.568970,240.350266 1467.182251,251.291870 1468.046021,262.213867 
	C1468.349731,266.053375 1466.747192,268.271454 1463.625122,270.300201 
	C1448.540039,280.102448 1431.984375,285.881622 1414.235718,287.842163 
	C1402.371216,289.152740 1390.360474,290.134583 1378.450195,289.842163 
	C1347.664429,289.086273 1318.815063,281.595001 1294.501587,261.584045 
	C1275.154663,245.660583 1262.859375,225.035446 1255.983032,201.029999 
	C1250.417480,181.600510 1248.912354,161.708344 1250.145386,141.721832 
	C1251.977051,112.036690 1260.342407,84.377136 1279.718018,61.133137 
	C1292.280518,46.062370 1307.998413,34.972328 1326.467407,28.029251 
	C1340.720825,22.670929 1355.364136,19.098232 1370.688110,18.985998 
	C1380.623657,18.913231 1390.560181,18.990974 1400.975464,19.001322 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M767.793335,267.582153 
	C766.170959,271.408752 764.635986,274.857758 763.128540,278.679626 
	C749.655823,316.282440 735.155212,353.188721 722.971436,390.844666 
	C713.191162,421.072052 706.037964,452.161163 698.067566,482.958069 
	C693.053589,502.331329 689.046570,521.920105 689.996948,542.143860 
	C690.020325,542.642456 689.852356,543.201538 690.023315,543.633606 
	C691.570068,547.543762 693.172546,551.431763 694.758606,555.326294 
	C697.993408,553.559204 702.015381,552.494812 704.327942,549.904419 
	C714.819092,538.152283 725.617188,526.541199 734.834290,513.814331 
	C750.490784,492.196289 765.033447,469.771973 780.059875,447.697174 
	C793.353882,428.167358 806.507935,408.539551 820.018738,389.160675 
	C835.023010,367.639679 849.933777,346.030579 865.681030,325.057251 
	C879.923096,306.088470 895.038452,287.760437 910.150818,269.465424 
	C919.792114,257.793610 930.129333,246.696777 940.153748,235.341400 
	C942.546936,232.630310 944.936707,229.916122 947.658020,227.135849 
	C948.007080,231.382248 948.026245,235.696182 948.016235,240.468994 
	C942.458923,247.000336 936.742615,252.913986 931.448730,259.184326 
	C924.374817,267.562897 917.550842,276.156860 910.758789,284.768158 
	C898.503845,300.305695 885.779663,315.515411 874.281067,331.598114 
	C852.869690,361.545288 831.863159,391.796143 811.320374,422.345764 
	C794.425598,447.470490 778.705078,473.382233 761.983459,498.626801 
	C747.036865,521.191589 731.530640,543.418152 711.457825,561.902039 
	C708.027954,565.060425 704.044189,567.971680 699.802612,569.815186 
	C692.554504,572.965271 683.426208,569.783020 681.116089,560.977844 
	C677.908630,548.752197 675.840088,536.419434 677.854736,523.611938 
	C679.381042,513.909119 679.651428,504.012360 681.072266,494.288361 
	C682.766968,482.690063 684.664368,471.087494 687.237000,459.658539 
	C692.194824,437.633148 697.266418,415.615814 703.083069,393.806396 
	C708.560974,373.266876 714.681091,352.877441 721.209229,332.644806 
	C728.339417,310.546600 736.262451,288.704224 744.230530,266.240295 
	C747.696960,258.129333 750.772705,250.528397 753.848389,242.927444 
	C758.872070,234.061691 763.663513,225.052948 769.002075,216.381012 
	C772.498657,210.701050 778.841736,210.183014 783.337158,215.010986 
	C785.587646,217.427994 787.478088,220.449188 788.649536,223.532211 
	C790.037537,227.185364 788.770813,230.324890 785.472839,233.030106 
	C782.626709,235.364670 779.840088,238.329269 778.319763,241.613663 
	C774.453979,249.965240 771.312256,258.652008 767.793335,267.582153 
z"
      />
      <path
        fill="#26262B"
        opacity="1.000000"
        stroke="none"
        d="
M1220.731445,280.058044 
	C1219.995728,281.992401 1218.861938,283.902832 1217.402466,285.911285 
	C1193.243774,286.005798 1169.411011,286.002869 1145.578125,285.997284 
	C1144.244995,285.996948 1142.825073,286.257843 1141.603149,285.883057 
	C1140.381470,285.508270 1139.357788,284.487579 1138.247314,283.750000 
	C1139.350586,282.842194 1140.391113,281.248993 1141.567505,281.141388 
	C1147.719116,280.578918 1153.231445,278.771973 1157.939819,274.611298 
	C1163.613647,269.597229 1165.879883,262.944244 1165.896484,255.845520 
	C1166.055054,188.013947 1166.053467,120.181755 1165.943726,52.349991 
	C1165.920410,37.938988 1156.752319,28.524439 1142.260620,26.907333 
	C1140.839478,26.748753 1139.562622,25.295427 1138.218750,24.443117 
	C1139.606689,23.633331 1140.991211,22.124212 1142.383179,22.117067 
	C1169.715332,21.976828 1197.048340,21.977406 1224.380493,22.103619 
	C1225.839233,22.110355 1227.291748,23.476196 1228.747070,24.209316 
	C1227.326782,25.142660 1225.979004,26.741898 1224.474854,26.905695 
	C1210.465210,28.431288 1201.094849,38.002293 1201.067993,52.114067 
	C1200.938721,120.112411 1200.941895,188.111282 1201.073975,256.109619 
	C1201.098511,268.690796 1209.092407,278.125885 1220.731445,280.058044 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M1344.671753,423.694946 
	C1348.660645,421.177490 1352.429688,418.171417 1356.688965,416.255157 
	C1363.368896,413.250031 1367.557739,417.107971 1367.991943,423.525879 
	C1368.347656,428.784332 1368.711914,434.042938 1368.989258,439.305878 
	C1369.473633,448.494659 1376.429565,453.434387 1385.548950,451.148071 
	C1404.879395,446.301758 1421.021729,435.886261 1435.725464,422.826813 
	C1441.733765,417.490387 1447.723999,412.035095 1454.333984,407.531281 
	C1456.479004,406.069733 1461.484619,406.263428 1463.545654,407.839539 
	C1466.378906,410.006256 1465.895142,414.529083 1463.182007,417.121368 
	C1454.854736,425.077484 1452.802734,435.750580 1450.125244,446.097260 
	C1447.154785,457.576080 1444.724731,469.195190 1442.108643,480.764374 
	C1441.901855,481.678955 1442.081421,482.680939 1442.081421,484.195068 
	C1450.692749,482.155273 1457.937256,478.439667 1464.842773,473.799500 
	C1466.409668,472.746674 1468.708984,472.784058 1470.671143,472.319580 
	C1469.821167,474.205444 1469.491699,476.801819 1468.039551,477.865509 
	C1455.735596,486.877716 1442.517090,493.976746 1427.394531,497.299042 
	C1405.190552,502.177124 1392.352661,487.289246 1393.064697,468.102692 
	C1393.115723,466.723572 1393.644653,464.962952 1394.601929,464.108612 
	C1396.104370,462.767578 1398.330200,461.088257 1399.930054,461.369781 
	C1401.200195,461.593353 1402.287720,464.435913 1402.933228,466.297119 
	C1404.242676,470.072815 1404.696533,474.211670 1406.402344,477.769745 
	C1410.035522,485.348206 1417.190063,485.826233 1424.222046,484.857941 
	C1429.905518,484.075317 1432.337036,479.327484 1434.018188,474.310822 
	C1438.694946,460.354523 1442.101440,446.138763 1443.040405,431.391388 
	C1443.161499,429.487610 1443.776001,427.615234 1444.458130,424.280548 
	C1438.254761,428.891907 1433.081665,432.708374 1427.939209,436.565735 
	C1415.223389,446.103943 1401.782104,454.383972 1386.207886,458.262726 
	C1373.025757,461.545776 1359.666626,455.964630 1359.986694,438.213959 
	C1360.074951,433.323242 1360.000244,428.429596 1360.000244,422.103729 
	C1356.057495,424.926239 1353.316650,426.589081 1350.922974,428.654449 
	C1341.315918,436.943909 1332.620361,446.008179 1327.042603,457.644897 
	C1325.708374,460.428253 1324.087891,463.073273 1322.641968,465.804688 
	C1320.113281,470.581421 1316.399292,472.686646 1313.289795,470.571655 
	C1309.538452,468.020050 1310.288086,464.049011 1311.822388,460.753235 
	C1317.595215,448.352997 1323.658813,436.087585 1329.666504,423.797546 
	C1330.896851,421.280762 1332.356323,418.875977 1334.231079,415.474396 
	C1318.711182,422.824219 1303.429077,426.366638 1286.877319,424.820099 
	C1289.850830,433.538483 1286.847778,440.711182 1282.812622,447.272797 
	C1277.028198,456.678314 1270.011230,465.130890 1260.417236,471.088837 
	C1256.472534,473.538605 1252.244263,474.349854 1248.458496,471.752167 
	C1244.473633,469.017792 1243.942139,464.783386 1245.903442,460.288177 
	C1248.363525,454.649719 1250.720459,448.966187 1253.244507,443.013000 
	C1249.015747,445.398224 1244.612915,447.849457 1240.240479,450.353760 
	C1224.944214,459.114349 1209.284058,467.089844 1192.061646,471.358582 
	C1188.605469,472.215302 1184.769653,472.298920 1181.220947,471.851349 
	C1175.579834,471.139923 1171.194214,464.621185 1172.044556,458.647705 
	C1174.146851,443.881500 1180.898193,431.137695 1190.031738,419.658386 
	C1192.755005,416.235748 1196.495483,413.413879 1200.263916,411.132782 
	C1201.799438,410.203278 1205.595581,410.652771 1206.648071,411.910309 
	C1207.814819,413.304504 1207.915894,416.848389 1206.932983,418.574799 
	C1201.539917,428.046570 1195.514771,437.156952 1190.052856,446.591827 
	C1188.145386,449.886841 1186.984497,453.683899 1185.919067,457.377533 
	C1184.776489,461.338867 1187.077148,463.617401 1190.732788,462.865540 
	C1197.216187,461.531982 1203.868774,460.126984 1209.852295,457.426239 
	C1226.932617,449.716614 1244.322998,442.425873 1259.427002,431.047211 
	C1263.408203,428.048035 1266.423462,423.784668 1269.980469,420.199249 
	C1273.553833,416.597534 1276.958862,412.715698 1281.027100,409.770905 
	C1282.784912,408.498474 1286.729492,408.266022 1288.374756,409.421204 
	C1289.792480,410.416748 1289.356934,414.051788 1289.772949,416.726440 
	C1303.630127,419.188049 1317.019409,413.954407 1330.350586,408.303253 
	C1333.930664,406.785614 1337.593628,405.343323 1341.354736,404.423431 
	C1343.222656,403.966583 1346.363037,404.048676 1347.208740,405.176270 
	C1348.456055,406.839355 1348.906982,409.842316 1348.370850,411.934875 
	C1347.458984,415.494171 1345.514771,418.789032 1343.691528,422.676849 
	C1343.328979,423.610138 1343.279419,424.061584 1343.229858,424.513062 
	C1343.710449,424.240387 1344.191162,423.967682 1344.671753,423.694946 
M1278.973755,430.339172 
	C1278.838989,430.090393 1278.744873,429.678955 1278.559326,429.632385 
	C1278.304688,429.568512 1277.873535,429.689178 1277.701782,429.888855 
	C1270.522949,438.240540 1264.391479,447.252563 1260.393433,457.617279 
	C1269.521240,450.825562 1277.408081,443.175079 1278.973755,430.339172 
z"
      />
      <path
        fill="#F26B25"
        opacity="1.000000"
        stroke="none"
        d="
M332.000580,375.982544 
	C332.000580,364.178406 332.000580,352.870575 332.000580,340.376038 
	C334.669098,341.518219 336.696320,342.385895 339.039856,343.388977 
	C346.258698,338.174622 354.516418,338.439514 361.273773,344.530975 
	C367.103333,338.884552 374.107056,338.482819 380.874542,341.617065 
	C387.090271,344.495819 391.063171,349.727631 391.015442,357.196625 
	C390.950897,367.305603 390.999390,377.415283 390.999390,387.759369 
	C386.605133,387.759369 382.669464,387.759369 377.999573,387.759369 
	C377.999573,380.061737 377.999603,372.313660 377.999573,364.565582 
	C377.999573,362.568054 377.933990,360.567902 378.014069,358.573578 
	C378.145386,355.302765 377.222382,353.186615 373.416718,352.943756 
	C369.288696,352.680359 368.273315,355.197052 368.048706,358.393585 
	C367.839203,361.375305 368.000153,364.383057 367.999847,367.379364 
	C367.999176,374.020294 367.999634,380.661224 367.999634,387.650391 
	C363.701324,387.650391 359.651459,387.650391 355.000366,387.650391 
	C355.000366,378.896423 355.005341,370.133575 354.995575,361.370728 
	C354.993896,359.875610 355.531006,357.813385 354.768036,357.003632 
	C353.182281,355.320679 350.983795,353.583710 348.852539,353.310791 
	C347.776947,353.173096 345.235016,356.143585 345.176605,357.773926 
	C344.825317,367.576477 345.002228,377.397949 345.002228,387.606354 
	C340.793304,387.606354 336.743896,387.606354 332.000580,387.606354 
	C332.000580,383.996155 332.000580,380.237518 332.000580,375.982544 
z"
      />
      <path
        fill="#257CE1"
        opacity="1.000000"
        stroke="none"
        d="
M114.001266,343.000305 
	C114.001266,336.204559 114.001266,329.908661 114.001266,323.308594 
	C118.393517,323.308594 122.441437,323.308594 126.860054,323.308594 
	C126.860054,329.701935 126.860054,335.962677 126.860054,341.085297 
	C132.315231,340.472870 137.734573,338.705658 142.636215,339.643677 
	C147.431625,340.561371 152.732971,343.291443 156.009613,346.874481 
	C166.921997,358.807251 164.005508,382.885529 145.912384,387.285950 
	C128.727219,391.465576 115.499916,383.679016 114.075264,363.467316 
	C113.608315,356.842773 114.001450,350.157623 114.001266,343.000305 
M142.147858,374.939056 
	C147.613464,371.963898 150.408295,367.572632 148.704941,361.175110 
	C147.796082,357.761627 144.454987,354.058899 141.230392,352.433868 
	C137.120880,350.362946 133.004791,352.760468 130.047775,356.448334 
	C126.774727,360.530396 126.456161,366.646667 129.424316,370.900299 
	C132.059433,374.676636 137.217285,376.450012 142.147858,374.939056 
z"
      />
      <path
        fill="#257CE1"
        opacity="1.000000"
        stroke="none"
        d="
M202.864883,342.979370 
	C216.389648,353.090271 215.015717,372.232208 205.982391,381.745331 
	C196.365891,391.872589 172.423920,390.880035 166.385559,372.161041 
	C161.136230,355.888031 173.063904,337.531586 190.584564,339.138031 
	C194.636017,339.509491 198.529465,341.604126 202.864883,342.979370 
M190.245636,352.009644 
	C183.263016,352.229462 179.254547,355.584534 178.042450,362.223633 
	C177.106781,367.348694 180.945297,373.268463 186.387222,375.092834 
	C191.279709,376.733063 196.319885,374.482178 198.771027,369.562408 
	C202.274841,362.529785 199.043442,355.192322 190.245636,352.009644 
z"
      />
      <path
        fill="#F26B25"
        opacity="1.000000"
        stroke="none"
        d="
M309.792053,387.099487 
	C293.079407,392.080139 278.370483,379.212616 278.578796,362.713379 
	C278.783813,346.473694 296.995331,332.298615 314.390625,341.947327 
	C322.875122,346.653381 326.498413,354.226746 326.105316,364.138519 
	C325.651917,375.570282 320.889587,382.988861 309.792053,387.099487 
M312.145264,369.407043 
	C314.576050,364.964325 313.852783,360.783508 311.268219,356.642181 
	C307.399750,350.443604 298.361938,350.351105 294.474396,355.421722 
	C289.872833,361.423645 290.423096,368.718719 295.977173,373.265717 
	C300.394714,376.882233 306.536774,377.293701 312.145264,369.407043 
z"
      />
      <path
        fill="#257CE1"
        opacity="1.000000"
        stroke="none"
        d="
M74.386932,353.451172 
	C74.115028,349.269348 74.115028,345.463531 74.115028,341.323944 
	C75.652771,341.118011 77.056290,340.930084 78.966446,340.674286 
	C78.966446,334.949982 78.966446,329.210052 78.966446,323.242065 
	C83.407066,323.242065 87.341011,323.242065 91.812790,323.242065 
	C91.812790,328.935791 91.812790,334.665314 91.812790,340.919373 
	C98.052063,340.919373 103.782066,340.919373 109.746521,340.919373 
	C109.746521,345.380249 109.746521,349.314117 109.746521,353.788635 
	C104.089508,353.788635 98.358620,353.788635 92.694336,353.788635 
	C91.306374,367.609863 89.470207,376.551910 109.617264,375.155334 
	C109.617264,379.224335 109.617264,383.277985 109.617264,387.658051 
	C100.259163,388.890808 91.146278,388.196198 84.418625,380.632263 
	C77.892799,373.295197 78.862213,363.826782 79.064865,354.471436 
	C77.465103,354.237549 76.061974,354.032379 74.386932,353.451172 
z"
      />
      <path
        fill="#F26B25"
        opacity="1.000000"
        stroke="none"
        d="
M255.476471,352.022675 
	C249.091766,354.243317 246.456863,359.077118 246.187881,364.910583 
	C245.960144,369.850342 249.933029,373.600220 255.715332,375.314789 
	C259.754639,376.512512 264.155426,374.242493 267.885254,368.864410 
	C270.748383,372.043030 273.578674,375.185211 276.490356,378.417725 
	C270.485413,386.798950 259.146942,391.175385 250.168060,387.536774 
	C238.844299,382.947906 232.645355,375.860138 233.983047,359.541534 
	C234.711868,350.650543 243.718796,340.876312 253.104797,339.044891 
	C262.164795,337.277100 272.932739,342.226959 276.909393,349.984314 
	C273.949585,352.835297 270.987976,355.688629 267.786011,358.773529 
	C264.961609,355.210754 261.873291,350.973267 255.476471,352.022675 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M483.000000,374.999725 
	C483.005859,371.004974 482.951630,367.505951 483.037354,364.010315 
	C483.101410,361.399750 483.391113,358.942535 487.008667,361.304779 
	C487.517487,361.637054 488.568024,361.579803 489.155975,361.283051 
	C495.228638,358.218109 500.659943,359.185638 504.894989,363.238861 
	C508.201721,361.887634 510.955688,360.308594 513.914612,359.649719 
	C519.689026,358.363861 525.399719,361.075287 526.009033,366.369049 
	C526.878784,373.926056 526.230347,381.657806 526.230347,389.314941 
	C525.703186,389.465698 525.176025,389.616455 524.648926,389.767212 
	C524.103821,388.209320 523.172729,386.672150 523.087769,385.089569 
	C522.856018,380.770905 523.094482,376.428833 522.933350,372.104004 
	C522.772644,367.790344 521.375061,364.177643 516.428894,363.404419 
	C512.669067,362.816620 508.655548,365.795166 507.785034,370.664093 
	C507.003326,375.035797 507.290710,379.591187 506.962524,384.054993 
	C506.829590,385.862854 506.314941,387.642578 505.973999,389.435120 
	C505.425568,389.456604 504.877106,389.478058 504.328644,389.499542 
	C503.889038,387.964630 503.142395,386.444092 503.069733,384.891968 
	C502.883057,380.903107 503.076996,376.898071 502.968292,372.903564 
	C502.813629,367.220154 499.744415,363.366821 495.470367,363.280884 
	C491.424561,363.199524 487.526367,367.202576 487.136688,372.354156 
	C486.823364,376.495941 487.152466,380.683594 486.923615,384.835846 
	C486.832245,386.493561 486.008118,388.110870 485.517548,389.746552 
	C484.678345,389.654083 483.839172,389.561646 483.000000,389.469177 
	C483.000000,384.811737 483.000000,380.154327 483.000000,374.999725 
z"
      />
      <path
        fill="#27262B"
        opacity="1.000000"
        stroke="none"
        d="
M753.639282,242.631180 
	C750.772705,250.528397 747.696960,258.129333 744.282715,265.860962 
	C743.630371,264.224915 743.049500,262.459015 743.043640,260.691254 
	C742.978943,241.029449 743.002930,221.367386 743.004639,201.705383 
	C743.004700,201.039001 742.786255,200.235123 743.078430,199.733383 
	C743.799683,198.494827 744.758850,197.394806 745.622375,196.239075 
	C746.406860,197.478073 747.722839,198.653305 747.880554,199.967514 
	C748.453308,204.740646 748.368652,209.597595 749.026306,214.354584 
	C750.319092,223.705582 751.943237,233.010773 753.639282,242.631180 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M560.757690,364.340881 
	C561.982544,368.898468 563.895142,373.204926 563.747620,377.439606 
	C563.410095,387.128967 552.904480,392.890442 543.438232,389.143524 
	C541.924805,388.544403 540.476379,387.781067 538.738403,386.973053 
	C536.691956,391.390198 539.820679,396.896606 536.345093,400.634186 
	C535.796509,400.555054 535.247925,400.475891 534.699341,400.396729 
	C534.699341,387.200989 534.699341,374.005280 534.699341,361.752197 
	C538.216980,361.176819 541.356323,360.761932 544.453064,360.135712 
	C550.445557,358.923950 555.988403,359.344208 560.757690,364.340881 
M540.470947,367.093384 
	C536.737610,372.751648 537.321594,380.428619 541.738281,383.753235 
	C546.685730,387.477448 554.023071,386.513672 557.738708,381.651611 
	C560.943115,377.458557 560.645142,370.649323 557.093933,366.918793 
	C552.671021,362.272583 547.384399,362.151001 540.470947,367.093384 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M644.352051,380.050232 
	C646.828003,384.766876 650.417786,386.713593 655.263733,385.618683 
	C659.788269,384.596405 662.815430,380.381561 662.967590,375.178345 
	C663.084534,371.181488 662.932007,367.174500 663.136292,363.184143 
	C663.183899,362.255096 664.193787,361.375397 664.760864,360.473022 
	C665.487793,361.382477 666.834656,362.284424 666.845703,363.202515 
	C666.956604,372.363739 667.207092,381.549255 666.657593,390.682190 
	C666.355469,395.704285 662.838318,399.310547 657.859131,400.406860 
	C652.071899,401.681091 646.179749,401.868286 641.466614,397.214752 
	C640.759766,396.516876 640.656799,395.207397 641.056580,393.036713 
	C642.630737,393.735413 644.312439,394.261627 645.759949,395.163544 
	C651.131409,398.510406 658.334045,397.563843 661.382874,392.759705 
	C662.339172,391.252777 662.549866,389.272644 662.770630,388.567291 
	C657.226501,388.661957 651.999817,389.460663 647.046509,388.629669 
	C642.401062,387.850281 639.949646,384.016846 640.000061,379.007782 
	C640.048706,374.175049 639.953430,369.340302 640.044556,364.508789 
	C640.070190,363.150146 640.529602,361.799652 641.789856,360.418060 
	C645.384338,366.507080 643.164429,373.318634 644.352051,380.050232 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M598.999451,382.739532 
	C598.765137,385.237701 598.531189,387.275787 598.178406,390.348846 
	C596.204590,388.825287 595.134644,387.999420 594.042419,387.156342 
	C584.849731,392.135803 575.705627,390.580750 571.507507,384.723480 
	C567.022034,378.465302 567.462708,369.221832 572.422485,364.085083 
	C577.977234,358.332092 585.972229,357.840820 593.658020,362.760162 
	C594.942749,361.985870 596.214233,361.219543 597.485718,360.453217 
	C597.988525,361.917664 598.881897,363.370636 598.925232,364.848541 
	C599.095459,370.654572 598.997925,376.468445 598.999451,382.739532 
M582.844849,363.290741 
	C581.587036,363.707092 580.284485,364.022461 579.079285,364.557434 
	C574.119202,366.759094 572.582214,370.806641 573.024963,375.929840 
	C573.436462,380.690582 575.645874,384.042328 580.321350,385.528625 
	C585.040527,387.028870 589.848999,385.572479 592.741638,381.621613 
	C597.353088,375.322937 595.100464,364.246857 582.844849,363.290741 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M17.002449,375.879089 
	C16.550282,369.481842 18.277222,364.064423 23.751707,361.548645 
	C29.606853,358.858002 35.993217,358.658295 41.961987,362.959351 
	C42.924000,362.115631 43.966160,361.201660 44.849586,360.426849 
	C47.627502,360.850342 48.001476,384.810486 45.418190,389.874481 
	C44.267670,388.940735 43.194077,388.069427 42.097576,387.179504 
	C28.854361,394.212402 16.686523,387.940491 17.002449,375.879089 
M21.105867,372.957092 
	C21.077385,373.786224 20.985840,374.618805 21.030436,375.443970 
	C21.375473,381.828369 26.112131,386.174286 32.481102,385.978882 
	C38.676414,385.788788 43.185387,380.850006 42.977066,374.482330 
	C42.781609,368.507751 39.644588,364.821533 33.880444,363.793152 
	C27.795734,362.707581 24.049150,365.184265 21.105867,372.957092 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M475.955078,368.403503 
	C477.721985,375.208069 477.761810,381.148010 472.370178,386.223511 
	C467.613770,390.701019 462.185120,390.696991 456.560760,389.242737 
	C449.480682,387.412048 444.958069,379.409912 446.486450,372.077332 
	C448.254272,363.596252 454.931854,358.426514 462.863739,359.511261 
	C468.506622,360.282959 473.626404,361.963806 475.955078,368.403503 
M453.160614,382.194977 
	C460.234833,388.269806 469.039154,386.891205 472.046051,379.237854 
	C474.134460,373.922333 472.645599,368.538483 468.262451,365.555603 
	C463.396667,362.244354 458.391144,362.554504 454.143738,366.430511 
	C450.341217,369.900543 449.779877,375.957581 453.160614,382.194977 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M956.347168,230.970612 
	C955.362854,227.738220 954.682617,224.338943 954.007690,220.505798 
	C961.989746,213.231476 969.956360,206.379227 977.955994,199.565704 
	C978.941467,198.726379 980.034912,197.649918 981.199097,197.471436 
	C982.850586,197.218231 984.614319,197.696960 986.330078,197.862930 
	C985.902771,199.386719 985.950684,201.389465 984.973511,202.359024 
	C976.736633,210.531204 968.289246,218.490723 959.968628,226.579483 
	C958.696289,227.816299 957.748901,229.387299 956.347168,230.970612 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M629.454590,370.000488 
	C628.164612,364.831421 624.445496,363.254547 620.278748,363.433502 
	C616.154358,363.610626 612.228333,365.453400 611.278687,369.999878 
	C610.407654,374.170258 610.384521,378.518646 610.003174,382.789978 
	C609.807007,384.987122 609.644287,387.187225 609.466431,389.386017 
	C608.854431,389.513092 608.242432,389.640137 607.630493,389.767212 
	C607.091248,388.202271 606.126831,386.648163 606.086609,385.070465 
	C605.912964,378.260681 605.942627,371.442780 606.065613,364.630859 
	C606.090271,363.266541 606.845947,361.915405 607.264648,360.558197 
	C608.568604,361.211182 609.872559,361.864197 610.720337,362.288757 
	C614.021729,361.310730 617.086060,360.032166 620.272278,359.535645 
	C627.054626,358.478668 633.139954,362.938995 633.752563,369.709351 
	C634.259583,375.313416 633.956543,380.997864 633.848816,386.643555 
	C633.830750,387.588654 632.978821,388.517853 632.512207,389.454376 
	C631.879761,389.428558 631.247375,389.402771 630.614990,389.376953 
	C630.274475,383.049866 629.933960,376.722748 629.454590,370.000488 
z"
      />
      <path
        fill="#231F20"
        opacity="1.000000"
        stroke="none"
        d="
M433.181458,359.835510 
	C435.437042,360.574921 437.592438,360.859161 439.085175,362.005920 
	C440.288086,362.930054 440.690491,364.896271 441.448029,366.400208 
	C439.945770,366.148895 438.197174,366.308228 436.981659,365.579010 
	C429.654114,361.183044 422.111694,363.499634 419.556244,371.113281 
	C417.865448,376.150787 419.548950,381.154114 423.986359,384.279602 
	C427.732880,386.918457 432.882996,386.482697 436.993134,383.589661 
	C438.355194,382.630951 440.309906,382.514252 441.993652,382.012573 
	C441.121704,383.909790 440.754822,386.480103 439.286194,387.582184 
	C434.202393,391.397095 424.421265,390.709869 419.606659,386.692993 
	C415.188263,383.006714 413.438293,374.165710 415.945984,368.199219 
	C418.560699,361.978149 424.939301,358.780579 433.181458,359.835510 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M1214.003540,382.423828 
	C1216.420410,376.318542 1221.664917,374.130280 1229.259277,376.273010 
	C1231.647583,376.946838 1233.635254,379.040253 1235.806274,380.483948 
	C1234.289307,382.734436 1233.105591,385.349091 1231.158936,387.130219 
	C1229.312622,388.819672 1226.782349,389.999725 1224.351929,390.768341 
	C1216.987793,393.097168 1214.005493,390.709381 1214.003540,382.423828 
z"
      />
      <path
        fill="#F26B25"
        opacity="1.000000"
        stroke="none"
        d="
M217.851868,374.673279 
	C224.378174,371.670288 228.031693,372.744934 230.354263,377.793396 
	C232.070084,381.523041 231.018829,385.218567 227.977188,386.686005 
	C225.352982,387.952087 221.154495,387.846741 218.468338,386.595398 
	C215.380981,385.157135 213.787582,381.594482 215.707169,377.782867 
	C216.210831,376.782776 216.942200,375.897400 217.851868,374.673279 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M1464.703369,522.998657 
	C1460.602173,522.999573 1456.966553,522.999573 1453.529297,522.999573 
	C1453.529297,517.925720 1453.529297,513.287476 1453.529297,508.143463 
	C1459.259033,507.207672 1458.528931,512.898193 1460.600342,515.629150 
	C1463.733276,513.991211 1461.039551,506.837128 1467.072266,508.121185 
	C1467.280762,512.356445 1467.635620,516.342346 1467.552734,520.319214 
	C1467.533813,521.228271 1466.003662,522.105713 1464.703369,522.998657 
z"
      />
      <path
        fill="#9E999E"
        opacity="1.000000"
        stroke="none"
        d="
M1440.672607,512.763000 
	C1440.201416,511.222412 1440.117676,509.799103 1440.025269,508.227173 
	C1444.172729,508.227173 1447.927368,508.227173 1451.792969,508.227173 
	C1451.792969,509.890442 1451.792969,511.325989 1451.792969,513.665833 
	C1449.931641,512.388062 1448.648926,511.507568 1446.517090,510.044037 
	C1447.152466,514.520569 1447.687622,518.290955 1448.282104,522.478699 
	C1447.024414,522.478699 1445.112305,522.478699 1443.336548,522.478699 
	C1443.632446,518.511353 1443.922119,514.628479 1444.211792,510.745605 
	C1443.670776,510.327881 1443.129761,509.910126 1442.588867,509.492371 
	C1442.079224,510.621674 1441.569702,511.750977 1440.672607,512.763000 
z"
      />
    </SvgIcon>
  );
};
